import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Grid, TextField } from "@material-ui/core";
import { ModalV2 } from "components/Modal/ModalV2";
import RegularButton from "components/CustomButtons/Button";
import { api_post, PROYECT } from "services/api";
import { useSearch } from "hooks/useSearch";
import { updateNoteFolio } from "redux/actions/routesStatus/routesStatusAction";

export const ReassignFolioModal = ({ open, onClose, note }) => {
  const dispatch = useDispatch();
  const [newFolio, setNewFolio] = useState("");
  const [loading, setLoading] = useState(false);
  const { setSnackbar } = useSearch();

  const handleSubmit = async () => {
    if (!note?.id) return;
    if (!newFolio.trim()) return setSnackbar("Ingrese el nuevo folio", "warning");
    if (Number(newFolio) === Number(note?.folio)) return setSnackbar("El folio nuevo debe ser diferente al actual", "warning");
    setLoading(true);
    try {
      const resp = await api_post(`${process.env.REACT_APP_URL}${PROYECT}/notes/change-folio`, {
        idNote: note?.id,
        newFolio: Number(newFolio),
      });
      dispatch(updateNoteFolio(note?.id, Number(newFolio)));
      setSnackbar(resp?.message || "Folio reasignado correctamente", "success");
      handleClose();
    } catch (err) {
      setSnackbar(err || "Error al reasignar folio", "danger");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setNewFolio("");
    onClose();
  };

  return (
    <ModalV2
      open={open}
      onClose={handleClose}
      title="Reasignación de folio a nota de crédito"
      halfScreen
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Folio Actual"
            value={note?.folio || ""}
            variant="outlined"
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Folio Nuevo"
            value={newFolio}
            onChange={(e) => setNewFolio(e.target.value.replace(/[^0-9]/g, ""))}
            variant="outlined"
            fullWidth
            autoFocus
          />
        </Grid>
        <Grid item xs={6}>
          <RegularButton
            fullWidth
            color="transparent"
            onClick={handleClose}
            disabled={loading}
          >
            Cancelar
          </RegularButton>
        </Grid>
        <Grid item xs={6}>
          <RegularButton
            fullWidth
            color="info"
            onClick={handleSubmit}
            loading={loading}
            disabled={!newFolio.trim()}
          >
            Aceptar
          </RegularButton>
        </Grid>
      </Grid>
    </ModalV2>
  );
};
